<script lang="ts">
  import { Control, setupControl } from "./controls";
  import FormField from "./FormField.svelte";
  import { Validator, type ValidatorMessages } from "./validators";
  import type { ControlValidator } from "./validators";
  import { EnquiryTranslations } from "../enquiry/Enquiry.i18n";

  // either set name and validators
  export let name: string = null;
  export let required: boolean = false;
  export let validators: ControlValidator[] = [];
  export let value: [string, string] = undefined;
  // ... or bind a control
  export let control: Control = null;
  export let standalone: boolean = false;
  export let displayName: string;
  export let errors: ValidatorMessages = undefined;

  export let language: string;

  $: T = EnquiryTranslations(language);

  const changes = setupControl(Control, {
    name,
    validators: [...validators, ...(required ? [Validator.required] : [])],
    value,
    control,
    standalone,
  });
  $: ctrl = $changes;

  let oldValue = value;
  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value;
  }

  $: arrival = formatValue((ctrl.value || [])[0]);
  $: departure = formatValue((ctrl.value || [])[1]);

  function formatValue(isoDate: string) {
    return T.format(isoDate, "ddd, dd. MMMM yyyy") || "—.—.—";
  }

  function setValue(value: [string, string] | undefined) {
    ctrl.value = value;
    ctrl.touch();
  }
</script>

<FormField bind:control={ctrl} {displayName} {errors} {standalone} on:change>
  <date-picker class="input-control input-daterange" {language} min-date="now" min-stay="1" mode="content" overlay="modal" value={ctrl.value} on:input={(_) => setValue(_.target.value)} class:input-error={ctrl.invalid} class:input-valid={ctrl.valid} class:input-dirty={ctrl.dirty} readonly>
    <div>
      <span>{T.get("dateRange.arrival")} *</span>
      {arrival}
    </div>
    <div>
      <span>{T.get("dateRange.departure")} *</span>
      {departure}
    </div>
  </date-picker>
</FormField>

<style lang="scss" global>
  .input-daterange {
    display: flex;
    justify-content: stretch;
    cursor: pointer;

    div {
      flex: 1 1 auto;
      text-align: center;
      padding: 0 0.5em;
      font-size: 14px;
      font-weight: bold;

      span {
        display: block;
        font-weight: normal;
        color: rgba(#000, 0.8);
      }
    }

    > div + div {
      border-left: solid 1px rgba(#000, 0.3);
    }
  }
</style>
